<template>
  <div>
    <template v-if="rounds.length === 0">
      <div class="text-center">
        <p>
          There are no funding rounds yet.
        </p>
        <base-button secondary @click="$modal.show('#addInvestmentFunding')">
          Add Funding Round
        </base-button>
      </div>
    </template>
    <template v-else>
      <template v-for="(round, i) in rounds">
        <form @submit.prevent="save(i)" :key="i">
          <base-card>
            <template v-slot:header>
              <base-card-heading>
                <template v-if="rounds[i]._id">
                  #{{ rounds[i]._id }}
                </template>
                <template v-else>
                  Not saved yet
                </template>
              </base-card-heading>
              <div>
                <template v-if="isActive(round._id)">
                  <span class="badge badge-success">ACTIVE</span>
                </template>
                <template v-else>
                  <base-button secondary small @click="setActive(i)">
                    Make Active
                  </base-button>
                </template>
              </div>
            </template>

            <div class="row">
              <div class="col-sm-6">
                <base-field label="Name">
                  <base-input v-model="rounds[i].name" placeholder="name" required />
                </base-field>
              </div>
              <div class="col-sm-6">
                <base-field addon-right-icon="percent" label="Interest Rate">
                  <base-input v-model="rounds[i].interestRate" numeric placeholder="interest rate" />
                </base-field>
              </div>
              <div class="col-sm-6">
                <base-field addon-left-icon="pound-sign" label="Funded">
                  <base-input v-model="rounds[i].funded" disabled numeric />
                </base-field>
              </div>
              <div class="col-sm-6">
                <base-field addon-left-icon="pound-sign" label="Funding">
                  <base-input v-model="rounds[i].funding" numeric placeholder="funding" required />
                </base-field>
              </div>
              <div class="col-sm-6">
                <base-field addon-left-icon="calendar-alt" label="Funding Start Date">
                  <base-input v-model="rounds[i].fundingStartAt" datepicker placeholder="start date" />
                </base-field>
              </div>
              <div class="col-sm-6">
                <base-field addon-left-icon="calendar-alt" label="Funding End Date">
                  <base-input v-model="rounds[i].fundingEndAt" datepicker placeholder="end date" />
                </base-field>
              </div>
              <div class="col-sm-6">
                <base-field addon-left-icon="calendar-alt" label="Accrue Start Date">
                  <base-input v-model="rounds[i].accrueStartAt" datepicker placeholder="start date" />
                </base-field>
              </div>
              <div class="col-sm-6">
                <base-field addon-left-icon="calendar-alt" label="Accrue End Date">
                  <base-input v-model="rounds[i].accrueEndAt" datepicker placeholder="end date" />
                </base-field>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-6">
                <base-checkbox v-model="rounds[i].overfunding">
                  Allow overfunding
                </base-checkbox>
                <base-checkbox v-model="rounds[i].fundingIndefinite">
                  Funding Indefinite
                </base-checkbox>
                <base-checkbox v-model="rounds[i].accrueIndefinite">
                  Accrue Indefinite
                </base-checkbox>
              </div>
            </div>

            <template v-slot:footer>
              <div class="text-right">
                <base-button class="mr-2" danger :disabled="round.funded > 0.00" icon-right="trash" @click="removeRound(round, i)">
                  Delete
                </base-button>
                <base-button :loading="saving === i" secondary submit>
                  Save Funding Round
                </base-button>
              </div>
            </template>
          </base-card>
        </form>
      </template>
      <div class="text-right">
        <base-button icon-right="plus" secondary @click="$modal.show('#addInvestmentFunding')">
          Add Funding Round
        </base-button>
      </div>
    </template>
    <investment-funding-create-modal @created="afterCreate" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import InvestmentFundingCreateModal from './InvestmentFundingCreateModal.vue'

export default {
  name: 'InvestmentFundingRounds',

  components: {
    InvestmentFundingCreateModal
  },

  data: () => ({
    rounds: [],
    saving: null
  }),

  created () {
    this.rounds = this.$_.cloneDeep(this.investment.rounds)
  },

  computed: {
    ...mapState({
      investment: store => store.core.investments.entity
    })
  },

  methods: {
    afterCreate (round) {
      this.rounds.push(round)
    },

    isActive (id) {
      return this.$_.get(this.investment.funding, '_id') === id
    },

    remove (round, i) {
      const message = `Are you sure you want to remove the funding round "${round.name}"?`

      this.$dialog.confirm(message, async () => {
        await Promise.all([
          this.removeRound(round._id),
          this.removeFromInvestment(round)
        ])

        this.rounds.splice(i, 1)
      })
    },

    save (i) {
      this.saving = i

      this.updateRound(this.rounds[i])
        .then(() => {
          this.$emit('refresh')
          this.$flash.success('Funding round successfully updated.')
        })
        .catch(err => this.$flash.failure(err))
        .finally(() => {
          this.saving = null
        })
    },

    setActive (i) {
      this.updateInvestment({
        _id: this.investment._id,
        funding: this.rounds[i]._id
      })
        .then(() => {
          this.$emit('refresh')
        })
        .catch(err => this.$flash.failure(err))
    },

    ...mapActions({
      removeRound: 'core/investment-funding/remove',
      removeFromInvestment: 'core/investments/rounds/pull',
      updateInvestment: 'core/investments/update',
      updateRound: 'core/investment-funding/update'
    })
  }
}
</script>
